export default {

  'comparison_analysis_date_comparison_title': "Date Comparison",
  'comparison_analysis_date_comparison_key_metrics_comparison': "Key Metrics Comparison",


  'comparison_analysis_date_comparison_statistics_date': "Statistics Date",
  'comparison_analysis_date_comparison_contrast_date': "Contrast Date",
  'comparison_analysis_date_comparison_more_metrics': "More Metrics",
  'comparison_analysis_date_comparison_key_metrics': "Key Metrics",
  'comparison_analysis_date_data_tips': "The numbers of statistics date and contrast date do not match, please reselect the contrast date.",
  'comparison_analysis_date_select_tips': "It is consistent with the Statistics Date.",

  'nightingale_comparison_analysis_date_comparison_title': "Date Comparison",
  'nightingale_comparison_analysis_key_performance': 'Key Performance',
  'nightingale_comparison_analysis_retention_tracking_comparison': 'Retention Tracking Comparison',
  'nightingale_comparison_analysis_return_rate': 'Return Rate',
  'nightingale_comparison_analysis_rolling_retention': 'Rolling Retention',
  'nightingale_comparison_analysis_metrics': 'Metrics',
  'nightingale_comparison_analysis_d1_d30': 'D1-D30',
  'nightingale_comparison_analysis_d1_d60': 'D1-D60',
  'nightingale_comparison_analysis_d1_d90': 'D1-D90',
  'nightingale_comparison_analysis_d1': 'D1',
  'nightingale_comparison_analysis_d2': 'D2',
  'nightingale_comparison_analysis_register_users' : 'New',
  'nightingale_comparison_analysis_d': 'D{num}',
  'nightingale_comparison_analysis_explain': 'The retention rate of new register users on day {num}. Registration date is day 0.',

  'pc_console_comparison_romeve_time':'Remove time',
  'pc_console_comparison_Up_to_6_times':'Up to 4 times',
  'pc_console_comparison_set_comparsion_time':'Set Comparison Time',
  
}
